<script>
import RawData from "@/components/widgets/raw-data.vue";
export default {
    components: {
        RawData
    },
    props: {
        type: {
            type: String,
            default: "pending",
        },
        list: Array,
        loading: Boolean,
    },
    data(){
        return {
            filter: null,
            perPage: 10,
            currentPage: 1,
            pageOptions: [10, 20, 50, 100],
            singleMode: true,
        }
    },
    computed: {
        filtered() {
            let data = this.list;
            var total = this.currentPage * this.perPage;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.clientName
                        .toLowerCase()
                        .includes(this.filter.toLowerCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows() {
            let data = this.list;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.clientName
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
        selectedAll: {
            get() {
                return this.list.every((x) => x.selected);
            },
            set(value) {
                this.list.forEach((x) => (x.selected = value));
            },
        },
        selectedBilling() {
            return this.list.filter((x) => x.selected);
        },
    },
    methods: {
        getDetails(row){
            if(this.type == 'unpaid'){
                console.log(row);
                return this.$emit('set-billing', row);
            }
            row.visible = !row.visible;
        },
        showItems(row){
            row.itemVisible = !row.itemVisible;
        },
        getTotal(billing, type){
            if(type == 'qty'){
                return billing.billingDetails.reduce((a, b) => {
                    return a + parseFloat(b.quantity);
                }, 0);
            }
            if(type == 'amount'){
                return billing.billingDetails.reduce((a, b) => {
                    return a + parseFloat(b.amount);
                }, 0);
            }
            return billing.billingDetails.reduce((a, b) => {
                return a + parseFloat(b.quantity) * parseFloat(b.amount);
            }, 0);
        },
        createBilling(){
            this.$emit('createBilling')
        },
        updateBilling(data){
            this.$emit('updateBilling', data)
        },
        removeBilling(id){
            this.$emit('removeBilling', id)
        },
        postBilling(id){
            this.$emit('postBilling', id)
        },
        printInvoice(bill){
            this.$emit('printInvoice', bill)
        },
        upperCaseFirst(str){
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        postMultipleBilling() {
            this.$emit('postMultipleBilling', this.selectedBilling);
        },
        markAsPaid(billing) {
            this.$emit('markAsPaid', billing);
        },
    }
}
</script>
<template>
    <div class="card" :class="{'shadow-none': type == 'unpaid'}">
        <div 
            class="card-body bg-soft"
            :class="{
                'bg-primary': type == 'pending',
                'bg-success': type == 'posted',
            }"
        >
            <div
                class="
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-3
                "
            >
                <div>
                    <h4 class="card-title mb-0">
                        {{upperCaseFirst(type)}} Billing List
                    </h4>
                    <p class="card-title-desc mb-0">
                        List of {{type}} billing <template v-if="type == 'pending'">(<a href="javascript:void(0);" @click="singleMode = !singleMode">{{singleMode ? 'Single' : 'Multiple'}} Selection</a>)</template>
                    </p>
                </div>
                <div class="d-flex">
                    <button 
                        type="button" 
                        class="btn btn-success me-1" 
                        v-if="!singleMode && selectedBilling.length"
                        @click="postMultipleBilling"
                    >
                        <i class="bx bx-check"></i> Post Selected Billing
                    </button>
                    <button 
                        type="button" 
                        class="btn btn-info me-1" 
                        v-if="type == 'pending'"
                        @click="createBilling"
                    >
                        <i class="bx bx-plus"></i> New Billing
                    </button>
                    <div class="d-flex" v-if="list.length > 0">
                        <input
                            autocomplete="off"
                            type="text"
                            v-model="filter"
                            placeholder="Search Billing..."
                            class="form-control"
                        />
                        <b-form-select
                            class="form-select ms-1 w-25"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                    </div>
                </div>
            </div>
            <div
                v-if="list.length == 0"
                class="text-center"
            >
                <h5>No data available</h5>
            </div>
            <div 
                v-if="filter && filtered.length == 0"
                class="text-center"
            >
                <h5>Search not found</h5>
            </div>
            <template v-if="list.length > 0">
                <div
                    class="
                        form-check
                        form-checkbox-outline
                        form-check-success
                        mb-0
                    "
                    v-if="type == 'pending' && !singleMode"
                >
                    <input
                        type="checkbox"
                        :id="`select-all-checkbox`"
                        class="form-check-input"
                        v-model="selectedAll"
                    />
                    <label :for="`select-all-checkbox`">Select All</label>
                </div>
                <template v-for="(x, index) in filtered">
                    <div class="d-flex"  :key="x.id">
                        <div
                            class="
                                form-check
                                form-checkbox-outline
                                form-check-success
                                mb-0
                            "
                            v-if="type == 'pending' && !singleMode"
                        >
                            <input
                                type="checkbox"
                                :id="`billing-checkbox-${x.id}`"
                                class="form-check-input"
                                v-model="x.selected"
                            />
                        </div>
                        <div role="tablist" class="w-100">
                            <b-card
                                no-body
                                class="mb-1 shadow-none"
                                :class="{'border': type == 'unpaid'}"
                                :style="{
                                    'z-index': `${filtered.length - index}`,
                                }"
                                
                            >
                                <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" placement="left"/>
                                <b-card-header
                                    header-tag="header"
                                    role="tab"
                                    header-class="cursor-pointer"
                                    @click="getDetails(x)"
                                >
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 class="m-0">
                                                <a class="text-dark" href="javascript: void(0);">
                                                    &nbsp;
                                                    <span :title="x.clientType" class="line-height-1 me-1">
                                                        <i class="font-size-18 bx" :class="{
                                                            'bx-user-voice': x.clientType.toLowerCase() == 'client',
                                                            'bx-run': x.clientType.toLowerCase() == 'walk-in',
                                                            'bx-user-circle': x.clientType.toLowerCase() == 'employee',
                                                        }"></i>
                                                    </span>
                                                    <span class="text-warning me-1">{{ x.clientName}}</span>
                                                    :&nbsp;
                                                    {{ x.description }}
                                                    <small v-if="x.status.toLowerCase() == 'paid'" class="bg-green rounded px-2">{{ x.status }}</small>
                                                </a>
                                            </h6>
                                            <small>From {{formatDate(new Date(x.billingDate))}} to {{formatDate(new Date(x.dueDate))}}</small>
                                        </div>
                                        <div class="d-flex align-items-center" v-if="type != 'unpaid'">
                                            <div>
                                                <span class="d-flex align-items-center text-truncate">
                                                    <small v-if="!x.visible">Click here to expand</small>
                                                    <i 
                                                        class="bx bx-chevron-right rotate font-size-18 ms-3"
                                                        :class="{'rotate-90': x.visible}"
                                                    ></i
                                                ></span>
                                            </div>
                                        </div>
                                    </div>
                                </b-card-header>
                                <b-collapse
                                    :visible="x.visible"
                                    :accordion="`accordion-${x.id}`"
                                    role="tabpanel"
                                >
                                    <b-card-body class="border">
                                        <div class="d-flex align-items-center justify-content-between cursor-pointer" @click="x.showDetails = !x.showDetails">
                                            <div class="d-flex align-items-end">
                                                <h5 class="mb-0 me-1 text-info">
                                                    Billing Details
                                                </h5>
                                            </div>
                                            <h5 class="mb-0">
                                                <i 
                                                    class="bx bx-chevron-right rotate"
                                                    :class="{'rotate-90': x.showDetails}"
                                                ></i>
                                            </h5>
                                        </div>
                                        <b-collapse
                                            :visible="x.showDetails"
                                            :accordion="`detail-accordion-${x.id}`"
                                            role="tabpanel"
                                        >
                                            <hr />
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <p>
                                                        <small class="d-block">Service from Delivery Unit:</small>
                                                        <span class="text-yellow ms-3" v-if="x.deliveryUnitService">{{ x.deliveryUnitService.deliveryUnit ? x.deliveryUnitService.deliveryUnit.name : '' }} - </span>
                                                        <span class="text-yellow" v-if="x.deliveryUnitService">{{ x.deliveryUnitService.serviceName }}</span>
                                                        <span class="text-yellow" v-else>N/A</span>
                                                    </p>
                                                    <p>
                                                        <small class="d-block">Client:</small>
                                                        <span class="text-yellow ms-3">{{ x.clientName }}</span>
                                                    </p>
                                                    <p>
                                                        <small class="d-block">Client Address:</small>
                                                        <span class="text-yellow ms-3">{{ x.clientAddress }}</span>
                                                    </p>
                                                    <p>
                                                        <small class="d-block">Client TIN:</small>
                                                        <span class="text-yellow ms-3">{{ x.clientTin }}</span>
                                                    </p>
                                                </div>
                                                <div class="col-md-6">
                                                    <p>
                                                        <small class="d-block">Description:</small>
                                                        <span class="text-yellow ms-3">{{ x.description }}</span>
                                                    </p>
                                                    <p v-if="type != 'pending'">
                                                        <small class="d-block">Reference #:</small>
                                                        <span class="text-yellow ms-3">{{ x.reference }}</span>
                                                    </p>
                                                    <div class="d-flex">
                                                        <p class="me-5">
                                                            <small class="d-block">Billing Date:</small>
                                                            <span class="text-yellow ms-3">{{ formatDate(new Date(x.billingDate)) }}</span>
                                                        </p>
                                                        <p>
                                                            <small class="d-block">Due Date:</small>
                                                            <span class="text-yellow ms-3">{{ formatDate(new Date(x.dueDate)) }}</span>
                                                        </p>
                                                    </div>
                                                    <p>
                                                        <small class="d-block">Penalty Per Day:</small>
                                                        <span class="text-yellow ms-3">{{ x.penaltyPerDay }}%</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </b-collapse>
                                        <hr />
                                        <div 
                                            class="d-flex align-items-center justify-content-between cursor-pointer"
                                            @click="showItems(x)"
                                        >
                                            <div>
                                                <h5 class="mb-0 text-green">Billing Items</h5>
                                            </div>
                                            <h5 class="mb-0">
                                                <i 
                                                    class="bx bx-chevron-right rotate"
                                                    :class="{'rotate-90': x.itemVisible}"
                                                ></i>
                                            </h5>
                                        </div>
                                        <b-collapse
                                            :visible="x.itemVisible"
                                            :accordion="`item-accordion-${x.id}`"
                                            role="tabpanel"
                                        >
                                            <hr />
                                            <table class="table table-bordered table-hovered table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Fee</th>
                                                        <th class="text-center">Quantity</th>
                                                        <th>Amount</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-if="x.billingDetails.length">
                                                        <tr v-for="y of x.billingDetails" :key="y.id">
                                                            <td>
                                                                {{y.fee}}
                                                                <small class="d-block">{{y.account}}</small>
                                                            </td>
                                                            <td class="text-center">{{y.quantity}}</td>
                                                            <td class="text-right">{{formatCurrency(y.amount)}}</td>
                                                            <td class="text-right">{{formatCurrency(parseFloat(y.quantity) * parseFloat(y.amount))}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right py-1" colspan="3"><span class="text-yellow font-size-18">Grand Total:</span></td>
                                                            <td class="font-size-18 py-1 text-right">
                                                                <span class="text-yellow">{{formatCurrency(getTotal(x, 'total'))}}</span>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                    <template v-else>
                                                        <tr>
                                                            <td colspan="100%">No data found.</td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </b-collapse>
                                        <hr>
                                        <div class="text-right">
                                            <template v-if="type == 'pending'">
                                                <button class="btn btn-primary me-1" @click="updateBilling(x)"><i class="bx bx-edit"></i> Update</button>
                                                <button class="btn btn-danger me-1" @click="removeBilling(x.id)"><i class="bx bx-trash"></i> Remove</button>
                                                <button class="btn btn-success" @click="postBilling(x.id)"><i class="bx bx-check"></i> Post</button>
                                            </template>
                                            <template v-else>
                                                <button class="btn btn-success me-1" @click="markAsPaid(x)" v-if="x.status.toLowerCase() !== 'paid'"><i class="bx bx-check-double"></i> Mark as Paid</button>
                                                <button class="btn btn-purple" @click="printInvoice(x)"><i class="bx bx-printer"></i> Generate Invoice</button>
                                            </template>
                                        </div>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>
                        </div>
                    </div>
                </template>
                <div class="row mt-3">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-end"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>